import { Alert, Box, Button, FormControl, Grid, MenuItem } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React, { useContext, useState } from "react";
import {
  StyledInputLabel,
  StyledSelect,
} from "../../components/FormElements/CustomSelect";
import { SunriseContext } from "../../App";
import dayjs from "dayjs";
import heatmapService from "../../services/HeatmapService";
import { useKeycloak } from "@react-keycloak/web";
import rtmData from "../../data/rtmHeatmapData.json";

function Heatmaps() {
  const { organisation } = useContext(SunriseContext);
  const { keycloak } = useKeycloak();

  const [time, setTime] = useState();
  const [date, setDate] = useState();
  const [station, setStation] = useState();
  const [line, setLine] = useState();
  const [heatmapContent, setHeatmapContent] = useState(null);
  const [heatmapError, setHeatmapError] = useState(false);

  const timePeriods = [
    { name: "Daily", id: "daily" },
    { name: "Weekly", id: "weekly" },
    { name: "Monthly", id: "monthly" },
  ];

  let datePickerStartDate =
    organisation === "TT"
      ? new Date("2020-06-18")
      : organisation === "RTM"
      ? new Date("2021-01-01")
      : new Date();

  let datePickerEndDate =
    organisation === "TT"
      ? new Date("2024-04-02")
      : organisation === "RTM"
      ? new Date("2024-09-30")
      : new Date();

  const handleTimeChange = (e) => {
    setHeatmapContent(null);
    setHeatmapError(false);
    setTime(e.target.value);
  };

  const onDateChange = (event) => {
    setHeatmapContent(null);
    setHeatmapError(false);
    let a = event.$y + "-";
    let b = event.$M + 1;
    if (b.toString().length === 1) {
      b = "0" + b.toString();
    }
    let c = "";
    if (event.$D.toString().length === 1) {
      c = "-0" + event.$D.toString();
    } else {
      c = "-" + event.$D;
    }

    setDate(a + b + c);
  };

  const getHeatmapHandler = () => {
    setHeatmapContent(null);
    setHeatmapError(false);

    if (organisation === "TT") {
      heatmapService
        .getHeatmapForTT(keycloak.token, date, time)
        .then((response) => {
          setHeatmapContent(response.data);
        })
        .catch((error) => {
          setHeatmapError(true);
        });
    } else if (organisation === "RTM") {
      heatmapService
        .getHeatmapForRTM(keycloak.token, date, time, line)
        .then((response) => {
          setHeatmapContent(response.data);
        })
        .catch((error) => {
          setHeatmapError(true);
        });
    }
  };

  const handleStationChange = (e) => {
    setHeatmapContent(null);
    setHeatmapError(false);
    setStation(e.target.value);

    let stationLine = rtmData.find(
      (element) => element.station_name === e.target.value
    );
    if (stationLine) {
      setLine(stationLine.line);
    }
  };
  return (
    <div id="heatmaps-wrapper">
      <div className="dashChart">
        <form>
          <div className="flexBox">
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12} md={12}>
                  <div
                    className="chartBox chartOptions flex-column"
                    style={{ gap: "16px", alignItems: "flex-start" }}
                  >
                    <h2 className="grafanaTitle">Heatmaps</h2>
                    <p>
                      Choose the desired date & time period (interval) from the
                      options below to get the corresponding heatmaps.{" "}
                    </p>
                    <div className="dashChart flexBox">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          onChange={onDateChange}
                          minDate={dayjs(datePickerStartDate)}
                          maxDate={dayjs(datePickerEndDate)}
                          slotProps={{
                            textField: { required: true },
                          }}
                        />
                      </LocalizationProvider>
                      <FormControl sx={{ minWidth: "260px" }}>
                        <StyledInputLabel htmlFor="timePeriod">
                          Time period
                        </StyledInputLabel>
                        <StyledSelect
                          labelId="timePeriod"
                          label="timePeriod"
                          onChange={handleTimeChange}
                          value={time}
                          required
                        >
                          <MenuItem value=""></MenuItem>
                          {timePeriods.map((period, index) => (
                            <MenuItem
                              key={`${index}-${period.id}`}
                              value={period.id}
                            >
                              {period.name}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                      {organisation === "RTM" && (
                        <FormControl sx={{ minWidth: "260px" }}>
                          <StyledInputLabel htmlFor="station">
                            Station
                          </StyledInputLabel>
                          <StyledSelect
                            labelId="station"
                            label="station"
                            onChange={handleStationChange}
                            value={station}
                            required
                          >
                            <MenuItem value=""></MenuItem>
                            {rtmData.map((item, index) => (
                              <MenuItem
                                key={`${index}-${item.line}`}
                                value={item.station_name}
                              >
                                {item.station_name}
                              </MenuItem>
                            ))}
                          </StyledSelect>
                        </FormControl>
                      )}
                    </div>
                    <br />
                    <div className="dashChart">
                      <FormControl size="small" fullWidth={true}>
                        <div className="flexBox flexEnd">
                          <Button
                            variant="contained"
                            size="medium"
                            onClick={getHeatmapHandler}
                          >
                            Get heatmaps
                          </Button>
                        </div>
                      </FormControl>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
        </form>

        {heatmapContent && (
          <div
            className="heatmap-result chartOptions chartBox"
            dangerouslySetInnerHTML={{ __html: heatmapContent }}
          />
        )}
      </div>
      {heatmapError && (
        <div className="flexBox flexCenter" style={{ marginTop: "16px" }}>
          <Alert severity={"error"}>
            Failed to get requested heatmap. Try again later.
          </Alert>
        </div>
      )}
    </div>
  );
}

export default Heatmaps;
